import type { PathConfig } from '@react-navigation/native';
import { linking as billboardLinking } from './billboard/navigator';
import { linking as chatLinking } from './chat/navigator';
import { linking as managementLinking } from './management/navigator';
import { linking as notificationsLinking } from './notifications/navigator';
import { linking as profileLinking } from './profile/navigator';
import type { Parameters } from './main-tab';

export const linking: PathConfig<Parameters> = {
  path: '/main',
  screens: {
    billboard: billboardLinking,
    chat: chatLinking,
    management: managementLinking,
    notifications: notificationsLinking,
    profile: profileLinking,
  },
};
